module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("PROLOGUE")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Carmarthen, Wales")]), _vm._v(" "), _c('p', {
    staticClass: "center1b"
  }, [_vm._v("June 1783")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("J")]), _vm._v("uliana St. Albans knew hardly anyone at her betrothal dinner. Her family had invited only the cream of Carmarthen society, so most other guests were English nobility connected with her betrothed. A twenty-course feast awaited them, champagne already flowed freely, and a costly orchestra was playing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She would have preferred less ostentation, but whatever Darcy St. Albans, the Earl of Northcliffe, wanted, he got. And her brother wanted to impress everyone with his newfound wealth, particularly her husband-to-be—Stephen Wyndham, Marquess of Devon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Believing the marquess to be as ambitious as himself, Darcy had already invested in a mining project with Stephen. But her kind and considerate betrothed was nothing like her bullying brother. Stephen was more like Rhys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the image of a tall, lean man with eyes blue as the Celtic sea leapt into her mind, she frowned. Why couldn’t she evict Rhys Vaughan from her thoughts?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("I’m not betraying him by doing this. I’m not!")])])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He was dead, for pity’s sake! She had a right to be happy, to have children at last. At twenty-seven, she wasn’t getting any younger. And since her one glorious night with Rhys six years ago hadn’t given her a child . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A blush stained her cheeks. “Oh bother.” Lifting her skirts, she headed for the stairs. She refused to spend one more "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("moment")]), _vm._v(" thinking about a man who hadn’t even tried to write her in the years before his death.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As she descended the wide staircase, the guests—and her betrothed—turned to watch. The attention made her squirm, especially when Stephen’s hot gaze raked down to linger on the swells of her breasts. Why did that make her uncomfortable?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When she reached his side, he offered her his arm. “The beauty has arrived at last.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She took it with a smile. She was being silly. Of course her betrothed found her desirable. And she couldn’t have children unless he did. “Good evening, my lord. You’re looking handsome this evening.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before he could reply, the others crowded around them offering congratulations. One elderly woman leaned in. “I suppose you’ll be moving out of Llynwydd, Lady Juliana.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stephen spoke for her. “Since Llynwydd belongs to her, of course we’ll repair there from time to time. But we shall live at Wyndham Castle in Devonshire.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That will certainly be a more pleasant place to reside,” the woman said. “And no doubt easier to manage, since you won’t have to deal with stupid and incompetent Welsh servants.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Juliana bristled. “I beg your pardon, but I do not hire stupid or incompetent servants. My Welsh staff is exemplary.”")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Squeezing her hand, Stephen hastened to add, “Juliana’s been fortunate in her choice of servants, but I’m sure she’ll find mine more agreeable. They’re all thoroughly English.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the woman sniffed and moved off to relate Juliana’s comments to her friends, Juliana bit back the impulse to correct Stephen. Thoroughly English indeed! If the surly staff at Wyndham Castle were indicative of the English nation as a whole, then England was in sad straits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is my sister waxing poetic about the Welsh again?” her other brother, Overton, came up to ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stephen flashed her an indulgent smile. “You know Juliana. She defends everyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unlike Darcy, Overton would probably rather be hunting with his rapscallion friends than hobnobbing with his peers. “I was wondering if you know that fellow by the window. He’s been glaring at you two ever since Juliana came downstairs. He looks familiar, but I can’t place him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Juliana turned to look, Overton added, “Damn. He must have walked off while we were talking. I’ll point him out later. Don’t like the looks of him. Not a congenial sort, I’ll wager.” Overton glanced at Stephen. “Hope he’s not one of your friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I doubt it.” Stephen scanned the room. “He’s probably some acquaintance of Darcy’s.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("While the two men continued talking, Juliana’s mind wandered. She wished she’d seen the man Darcy had spoken of. All this attention from strangers was unnerving. As ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("mistress of Llynwydd, the estate her father had given her, she’d led a solitary life. But Stephen had already warned her that they’d be doing a great deal of entertaining at Wyndham Castle.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She hated entertaining. She much preferred the challenge of running her estate, even though her parents and their English friends had thought it scandalous that a woman should live away from home and manage property alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fortunately, the Welsh tenants and staff didn’t care who ran Llynwydd as long as it was done efficiently, especially since it made a good profit, which had eventually silenced her family’s objections. A pity she had to leave it all behind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A servant stepped into the drawing room and announced that dinner was served, but Juliana scarcely noticed, wondering if she’d made a mistake in agreeing to marry Stephen. It wasn’t as if she loved him. She felt a great deal of affection and respect for him, but was that enough? Darcy’s marriage amply illustrated that matches not based on love could be disastrous.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Glancing at her sister-in-law, Elizabeth, Juliana tensed. The woman wore her usual carved-ice expression, which never cracked, even in the presence of her husband. Darcy’s reasons for marrying the young heiress had been thoroughly mercenary. But were Juliana’s reasons for marrying Stephen any different?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes, they were. There was nothing wrong with marrying for companionship. Even Llynwydd was lonely at night, in the dead of winter. She was tired of being alone. She wanted a husband and children.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Besides, she liked Stephen. They’d do nicely together.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Before she knew it, the meal had passed, and Darcy rose to begin the evening’s toasts. “Welcome, my friends, to this celebration,” he said in stentorian tones. “A year ago, this fine gentleman, the Marquess of Devon, came to court my sister, Juliana. And as luck would have it, they found favor in each other’s eyes.”")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A shadow passed over his face. “Although my father died before he’d had the chance to meet his lordship, I know he would have approved of the marquess. Lord Devon is one of the most respectable, intelligent, and engaging men I’ve ever known.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Darcy stood a little straighter, looking almost military in demeanor. “So tonight, my friends, I’m pleased to announce, on behalf of my mother and my late father, the betrothal of my sister to this honorable man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He held up his glass, his face flushing with pleasure. “A toast! To Lady Juliana and her husband-to-be, Stephen Wyndham, the Marquess of Devon! May their joy be unbounded! ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guests raised their glasses, preparing to cheer—but another voice rang out from the other end of the hall. “I dispute that toast! ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Darcy looked incredulous, as the other guests hesitated with their arms suspended in the air as if by invisible wires. Juliana’s heart dropped into her stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She searched for the man who’d spoken and found him at the other end of the ballroom. Towering over the other guests, he stood in the shadows, where she couldn’t make out his features. Was this the fellow Overton had spoken of?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("He was dressed more soberly than her guests, and his entire ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("bearing bespoke arrogance. The gasps of those around him had little effect, for he carried himself forward with the invincibility of a battleship.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He snatched a glass from a guest’s hand as he passed. “I would propose another toast entirely.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Something in his voice tweaked her buried memories. It couldn’t be. His accent wasn’t right. And as he came closer, she could see he wore the expensive attire of a lord, not the modest garb of a radical. What’s more, he was too big, too self-assured, and entirely too imposing to be . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But try as she could to deny it, her fear became a certainty as he strolled up the aisle to the head table. She stared at the broad shoulders, at the black curls cropped at the chin framing an arresting and painfully familiar face. She rose, not realizing that she did, disbelieving the evidence of her own eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Darcy seemed to regain his wits. “What preposterous rudeness is this? I don’t know you, sir, and I’m certain you weren’t invited. Leave at once, before I have my footmen throw you out! ” He signaled to a servant, who hastened toward the stranger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a sinister clang, the encroacher withdrew his sword and the summoned footman fell back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sure of his audience, the man came to within six feet of her. “If anyone should have been invited, ’tis I. But then, I’m sure you treacherous blackguards thought yourselves well rid of me.” He scanned the head table with a scathing glance. “Otherwise, you wouldn’t be engaging in this farce.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With her heart in her stomach, Juliana stared at the man’s face. ’Twas impossible!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Stephen jumped to his feet. “Treacherous blackguards! I’ll call you out for that, sir! ”")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah, but you have it all wrong, Lord Devon. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I")]), _vm._v(" should call "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("you")]), _vm._v(" out. Ask Juliana.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stephen shot her a questioning look, but Juliana took no notice as the man fixed his gaze on her, searing her. Her throat tightened and her knees shook. Only one man had those blue eyes. And for a moment, her heart leapt and she wanted to bound over the table into his arms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then she saw the coldness in his eyes, the anger in his face, and the urge fled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You should have told him, Juliana.” His voice held an edge of fury. “ ’Tis an important thing to leave out of any discussion about betrothal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It c-can’t be tr-true,” she whispered, stumbling over the words.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His eyes narrowed. “What? That I’ve returned? That I’ve come to reclaim my lands . . . my inheritance . . . and you? Oh yes, love. It is true.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The entire company was thrown into confusion, except for her brothers, who looked as if they’d commit murder any moment. It was like seeing a corpse rise from the grave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rhys, please.” She clasped her chair as her knees began to buckle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With an expression as cold as the frostiest winter, Rhys lifted his glass in a toast. “To Juliana, my darling wife. I’ve come to take you home.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("And for the first time in her life, Juliana fainted.")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d01bd39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 75
// module chunks = 0